export type DqGlobalProps = {
  id: number;
  shouldRenderAs?: "modal" | "default";
};

export enum QuestionTypes {
  MULTIPLECHOICE = 10,
  READING_MULTIPLECHOICE = 20,
  EXPLANATORY = 30,
  READING_EXPLANATORY = 40
}
